import { ContractingStateEnum } from 'v3/data/store/contracting/enums';

export const contractingStateMap = [
  ContractingStateEnum.ContractingStarted,
  ContractingStateEnum.ContractingDenied,
  ContractingStateEnum.ProcessingCreditAnalysis,
  ContractingStateEnum.CreditAnalysisRejected,
  ContractingStateEnum.WaitingProposalGeneration,
  ContractingStateEnum.WaitingDocuments,
  ContractingStateEnum.WaitingSelfie,
  ContractingStateEnum.CafRejected,
  ContractingStateEnum.WaitingRegistrationData,
  ContractingStateEnum.CpfBlocked,
  ContractingStateEnum.WaitingProposalAcceptance,
  ContractingStateEnum.WaitingTermsAcceptance,
  ContractingStateEnum.ProcessingAntiFraud,
  ContractingStateEnum.WaitingContractEffectiveness,
  ContractingStateEnum.ContractingFinished,
];
